import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDateFilters } from "./context/useDateFilters";
import { firstToUpper } from "../../../../utils/helpers/string";
import { cn } from "../../../../lib/utils";
import type { DateFiltersMode } from "./types";

function FilterMode() {
    const { t } = useTranslation();
    const { mode, modes, dispatch } = useDateFilters();
    const onModeChange = useCallback((value: DateFiltersMode) => {
        dispatch({ type: "set-mode", payload: { mode: value } });
        dispatch({ type: "set-pay-group", payload: { payGroupCode: undefined, payGroupId: undefined } });
        dispatch({ type: "set-pay-group-period", payload: { payGroupPeriod: "current" } });
    }, [dispatch]);

    return (
        modes.length > 1 && (
            <div className="tw-flex tw-align-center tw-m-0 tw-p-0 tw-border tw-border-color-secondary tw-w-fit tw-rounded-l-lg">
                {modes.map((option, i) => (
                    <span
                        key={option}
                        className={cn(
                            "tw-px-4 tw-py-2 tw-text-center tw-text-sm tw-cursor-pointer  tw-m-0 hover:tw-bg-accent hover:tw-text-accent-foreground",
                            i === 0 && "tw-rounded-l-lg",
                            i === modes.length - 1 && "tw-border-l-0",
                            i > 0 && i < modes.length - 1 && "tw-border-l-0",
                            mode === option ? "tw-bg-accent tw-text-accent-foreground tw-font-semibold" : "tw-bg-white tw-text-muted-foreground",
                        )}
                        onClick={() => onModeChange(option)}
                    >
                        {firstToUpper(t(option))}
                    </span>
                ))}
            </div>
        )
    );
}
export default FilterMode;
